export class AddThirdPartyEntity {
  static readonly type = '[Contract.Entity] Add';
  constructor(public entity: any, public interestID: string) {}
}

export class UpdateEntity {
  static readonly type = '[Contract.Entity] Update';
  constructor(public entity: any) {}
}

export class DeleteThirdPartyEntity {
  static readonly type = '[Contract.Entity] Delete';
  constructor(public entityID: string) {}
}

export class AddEntityAddressLink {
  static readonly type = '[Contract.Entity] Add Address Link';
  constructor(public entityID: string, public addressID: number) {}
}

export class RemoveEntityAddressLink {
  static readonly type = '[Contract.Entity] Remove Address Link';
  constructor(public entityID: string, public addressID: number) {}
}

export class AddEntityPhoneLink {
  static readonly type = '[Contract.Entity] Add Phone Link';
  constructor(public entityID: string, public phoneID: number) {}
}

export class RemoveEntityPhoneLink {
  static readonly type = '[Contract.Entity] Remove Phone Link';
  constructor(public entityID: string, public phoneID: number) {}
}

export class SetRetailBroker {
  static readonly type = '[Contract.Entity] Set Retail Broker';
  constructor(public entityID: number, public broker: any) {}
}

export class AddConsumer {
  static readonly type = '[Contract.Entity] Add Consumer';
  constructor(public consumer: any) {}
}
